export enum YearOverYearEnum {
  LAST_YEAR = 'ly',
  LAST_YEAR_CHANGE = 'lyd',
  LAST_YEAR_PERCENT_CHANGE = 'lypd',
  THIS_YEAR = 'ty'
}
